/*
 * @Author: your name
 * @Date: 2021-01-19 10:18:17
 * @LastEditTime: 2022-11-08 16:33:02
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/modules/navBar.js
 */

// Which pages need the Back to Previous button in the upper left corner
// 哪些页面需要显示左上角的 '返回上一页' 按钮
const enableShowArrowList = [
  'product-detail-table',
  'product-detail-pick',
  'cart-pick',
  'cart-table',
  'contact-details',
  'payment',
  'card-detail',
  'tab-user-pay',
  'tab-history',
  'start-tab',
  'verification-code'
]

const specialEnableShowArrowPageList = [
]

export {
  enableShowArrowList,
  specialEnableShowArrowPageList,
}